import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

import {
  hasSelectedTransmissionFilterSelector,
  resetSelectedTransmissionTypesSelector,
  selectedTransmissionTypesSelector,
  selectTransmissionTypeSelector,
  toggleTransmissionTypeSelector,
  transmissionCountState,
  transmissionTypeSearchOptionsSelector,
  transmissionTypesState,
  visibleTransmissionTypeSelector,
} from '@/states/filters/transmission-type.state';

export function useTransmissionTypeFilter() {
  const [transmissionTypeFilter, setTransmissionTypeFilter] = useRecoilState(
    transmissionTypesState
  );
  const [transmissionCount, setTransmissionCount] = useRecoilState(
    transmissionCountState
  );
  const transmissionTypeSearchOptions = useRecoilValue(
    transmissionTypeSearchOptionsSelector
  );
  const toggleTransmissionType = useSetRecoilState(
    toggleTransmissionTypeSelector
  );
  const selectTransmissionType = useSetRecoilState(
    selectTransmissionTypeSelector
  );
  const selectedTransmissionTypes = useRecoilValue(
    selectedTransmissionTypesSelector
  );
  const resetSelectedTransmissionTypes = useSetRecoilState(
    resetSelectedTransmissionTypesSelector
  );

  const hasSelectedTransmissionFilter = useRecoilValue(
    hasSelectedTransmissionFilterSelector
  );

  const visibleTransmissionTypeFilter = useRecoilValue(
    visibleTransmissionTypeSelector
  );

  return {
    transmissionTypeFilter,
    setTransmissionTypeFilter,
    transmissionCount,
    setTransmissionCount,
    transmissionTypeSearchOptions,
    toggleTransmissionType,
    selectedTransmissionTypes,
    resetSelectedTransmissionTypes,
    hasSelectedTransmissionFilter,
    selectTransmissionType,
    visibleTransmissionTypeFilter,
  };
}
